// extracted by mini-css-extract-plugin
export default {"containerFluid":"App_containerFluid__3wIHw"};